import React from 'react';
import { XCircle, AlertOctagon, Clock } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-gray-900 py-16 px-4" data-id="element-185">
      <div className="max-w-5xl mx-auto" data-id="element-186">
        <div className="flex items-center justify-center mb-10" data-id="element-187">
          <AlertOctagon size={32} className="text-amber-500 mr-3" data-id="element-188" />
          <h2 className="text-3xl font-bold text-white" data-id="element-189">
            Frustration Fractionation
          </h2>
        </div>
        <div className="bg-gray-800 rounded-lg shadow-md p-8 mb-12 border border-gray-700" data-id="element-190">
          <h3 className="text-2xl font-semibold text-gray-100 mb-6 text-center" data-id="element-191">
            Maybe you've already tried:
          </h3>
          <div className="space-y-6 mb-8" data-id="element-192">
            <div className="flex items-start" data-id="element-193">
              <XCircle size={24} className="text-amber-500 mr-3 mt-1 flex-shrink-0" data-id="element-194" />
              <p className="text-lg text-gray-300" data-id="element-195">
                Mimicking other leaders—sounding like them but not connecting.
              </p>
            </div>
            <div className="flex items-start" data-id="element-196">
              <XCircle size={24} className="text-amber-500 mr-3 mt-1 flex-shrink-0" data-id="element-197" />
              <p className="text-lg text-gray-300" data-id="element-198">
                Posting motivational quotes—feeling good for a moment, then
                forgotten.
              </p>
            </div>
            <div className="flex items-start" data-id="element-199">
              <XCircle size={24} className="text-amber-500 mr-3 mt-1 flex-shrink-0" data-id="element-200" />
              <p className="text-lg text-gray-300" data-id="element-201">
                Waiting for the "perfect moment"—that never really comes.
              </p>
            </div>
          </div>
          <div className="bg-gray-900 p-6 rounded-lg border border-gray-700" data-id="element-202">
            <div className="flex items-start" data-id="element-203">
              <Clock size={28} className="text-amber-500 mr-3 mt-1 flex-shrink-0" data-id="element-204" />
              <div data-id="element-205">
                <h4 className="text-xl font-semibold text-gray-100 mb-2" data-id="element-206">
                  And all the while...
                </h4>
                <p className="text-lg text-gray-300" data-id="element-207">
                  Frustration builds. Insecurity disguises itself as humility.
                </p>
                <p className="text-lg text-gray-300 mt-2" data-id="element-208">
                  And your influence... dissolves.
                </p>
                <p className="text-lg text-amber-400 mt-2 font-semibold" data-id="element-209">
                  But there's a way out. And it starts by taking control.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-210">
          <p className="text-xl text-gray-200" data-id="element-211">
            Are you ready to discover the method that will transform your
            leadership forever?
          </p>
        </div>
      </div>
    </section>;
}